module.exports = __webpack_public_path__ + "static/media/cevIcon.efd98477.svg";